import { createI18n } from "vue-i18n";
import { pt } from "vuetify/locale";

const messages = {
  pt: {
    $vuetify: {
      ...pt,
      confirmEdit: {
        cancel: "Cancelar",
        ok: "Confirmar"
      }
    },
    project: {
      FTX4: "Farmácias TX4",
      Shelf: "Xmart Shelf",
      products: ["", "Gôndola digital"]
    },
    login: {
      authentication: {
        title: "Login",
        subtitle: "Inicie sua experiência com a {name}",
        footer: ["Ainda não tem uma conta?", "Fale com nosso time!"],
        pwa: "Instale o webapp PWA em seu dispositvo."
      },
      twoFactor: {
        title: "Confirmação",
        subtitle:
          "Para confirmar o acesso, verifique o código enviado por email para:",
        timer: "Expira em {time}"
      },
      newPassword: {
        title: "Antes de continuar",
        subtitle: "Troque sua senha por segurança"
      },
      passwordStatus: {
        title: "Senha atualizada com sucesso",
        subtitle:
          "Para sua segurança a nova senha para acessar a XmartShelf foi redefinida com sucesso!"
      },
      recoverPassword: {
        title: "Recuperar senha",
        subtitle: "Insira seu email para recuperar sua senha",
        button: "Esqueci minha senha"
      }
    },
    home: {
      userName: "Olá, {name}",
      title: "Bem-vindo a {name}",
      subtitle: "Potencialize suas vendas!"
    },
    sales: {
      items: "Nenhum produto | 1 item | {count} itens",
      filters: {
        mobile: "Buscar por venda",
        desktop:
          "Buscar por pedido, id do locker, docas, nome ou documento do cliente"
      }
    },
    order: {
      items: "Nenhum produto | 1 produto | {count} produtos"
    },
    fields: {
      labels: {
        email: "Email",
        password: "Senha"
      }
    },
    buttons: {
      login: "Acessar",
      confirm: "Confirmar",
      dontGetCode: "Não recebi o código",
      updatePassword: "Atualizar Senha",
      backLogin: "Voltar ao login",
      send: "Enviar"
    }
  }
};

const i18n = createI18n({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: "pt",
  fallbackLocale: "pt",
  messages
});

export default i18n;
